import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'app/store';
import {
  setNewChat,
  setShowNewChatOverlay,
  selectShowNewChatOverlay,
} from 'modules/chatbot/slices/chatbotSlice';

import styles from './NewChatOverlay.module.less';

const NewChatOverlay: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const showOverlay = useSelector(selectShowNewChatOverlay);
  const [isClosing, setIsClosing] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (showOverlay) {
      setShouldRender(true);
      setIsClosing(false);
    } else if (shouldRender) {
      setIsClosing(true);
      // Wait for animation to complete before hiding
      const timer = setTimeout(() => {
        setShouldRender(false);
        setIsClosing(false);
      }, 300); // Match animation duration
      return () => clearTimeout(timer);
    }
  }, [showOverlay, shouldRender]);

  const handleYes = () => {
    dispatch(setNewChat());
    dispatch(setShowNewChatOverlay(false));
  };

  const handleCancel = () => {
    dispatch(setShowNewChatOverlay(false));
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    // Close overlay when clicking on the backdrop
    if (e.target === e.currentTarget) {
      handleCancel();
    }
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className={`${styles.overlay} ${isClosing ? styles.closing : ''}`}
      onClick={handleOverlayClick}
    >
      <div className={styles.modal}>
        <div className={styles.content}>
          <div className={styles.avatar}></div>
          <h2 className={styles.title}>Start a new chat?</h2>
          <p className={styles.description}>
            This chat won’t be saved once you close it. Do you still want to
            start a new session?
          </p>
          <div className={styles.actions}>
            <Button
              type="primary"
              className={styles.yesButton}
              onClick={handleYes}
            >
              Yes
            </Button>
            <Button className={styles.cancelButton} onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewChatOverlay;
